// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ml-0";
export var assigneeDetails = "_ml-1";
export var assigneeInfo = "_ml-2";
export var dropdownContainer = "_ml-4";
export var dropdownImage = "_ml-5";
export var editAssigneeInfo = "_ml-3";
export var editAssigneeModalContainer = "_ml-6";
export var hidden = "_ml-8";
export var input = "_ml-7";